// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Product----styles-module---wrapper---1pp9e","image":"src-components-Product----styles-module---image---1P36N","content":"src-components-Product----styles-module---content---2HtJx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Product/styles.module.scss
// module id = 107
// module chunks = 182974369400049 213534597649335